import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

interface NewsCard {
    image: string;
    imageAlt: string;
    date: string;
    title: string;
    route: string;
}

const NEWS_CARDS: NewsCard[] = [
    {
        image: "/images/blog-tuition-payment.avif",
        imageAlt: "Tuition Payment blog",
        date: "Publish on 27 Nov 2025",
        title: "Tuition Payment",
        route: "/tuition-payment-blog",
    },
    {
        image: "/images/blog-global-financial-connectivity.avif",
        imageAlt: "Global Financial Connectivity blog",
        date: "Publish on 27 Nov 2025",
        title: "Global Financial Connectivity",
        route: "/global-financial-connectivity-blog",
    },
    {
        image: "/images/blog-student-loan.avif",
        imageAlt: "Student Loan blog",
        date: "Publish on 27 Nov 2025",
        title: "AfriPay Student Loans — Smarter Funding for Your Global Education Journey",
        route: "/student-loan-blog",
    },
];

const ReadNewsArrow = () => (
    <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" strokeWidth="2" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m0 0l-3-3m3 3l-3 3" />
    </svg>
);

function BlogCard({ image, imageAlt, date, title, route }: NewsCard) {
    return (
        <motion.div variants={fadeUp} className="relative rounded-3xl overflow-hidden h-[460px] group cursor-pointer">
            <img src={image} alt={imageAlt} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 h-[50%] bg-gradient-to-t from-[#00B46F] via-[#00B46F] to-transparent" />
            <div className="relative h-full flex flex-col justify-between p-5">
                <div className="self-start">
                    <span className="inline-block bg-[#14B266] text-white text-[10px] px-4 py-1.5 rounded-full">{date}</span>
                </div>
                <div className="text-white">
                    <h3 className="text-xl font-[600] mb-4 leading-tight">{title}</h3>
                    <NavLink to={route}>
                        <button className="flex items-center gap-2 text-white hover:gap-3 transition-all duration-300">
                            <span className="text-[14px] hover:text-[#26A869]">Read news</span>
                            <ReadNewsArrow />
                        </button>
                    </NavLink>
                </div>
            </div>
        </motion.div>
    );
}

export default function NewsSection() {
    return (
        <div className="bg-[#fff] py-8 md:py-10 px-4">
            <motion.div
                variants={container}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                className="max-w-7xl mx-auto"
            >
                <motion.h2
                    variants={fadeUp}
                    className="font-display-fran font-semibold text-[#030319] text-[22px] md:text-3xl leading-[1.1] tracking-[-0.02em] text-center mb-6 md:mb-8"
                >
                    Get News with AfriPay
                </motion.h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
                    {NEWS_CARDS.map((card) => (
                        <BlogCard key={card.route} {...card} />
                    ))}
                </div>
            </motion.div>
        </div>
    );
}